import $ from 'jquery'

/**
 * Handle events in the settings panel.
 */
function listenToSettingsEvents() {
  $('.nav-settings').click(function() {
    $('#theme-settings').removeClass('open')
    $('#right-sidebar').toggleClass('open')
  })
  $('.settings-close').click(function() {
    $('#right-sidebar,#theme-settings,#color-settings').removeClass('open')
  })

  $('.navbar-nav .nav-item.color-setting').on('click', function() {
    $('#right-sidebar').removeClass('open')
    $('#theme-settings').toggleClass('open')
  })

  //background constants
  const navbar_classes = 'navbar-danger navbar-success navbar-warning navbar-dark navbar-light navbar-primary navbar-info navbar-pink'
  const sidebar_classes = 'sidebar-light sidebar-dark'
  const $body = $('body')

  //sidebar backgrounds
  $('#sidebar-light-theme').on('click', function() {
    $body.removeClass(sidebar_classes)
    $body.addClass('sidebar-light')
    $('.sidebar-bg-options').removeClass('selected')
    $(this).addClass('selected')
  })
  $('#sidebar-dark-theme').on('click', function() {
    $body.removeClass(sidebar_classes)
    $body.addClass('sidebar-dark')
    $('.sidebar-bg-options').removeClass('selected')
    $(this).addClass('selected')
  })

  //Navbar Backgrounds
  $('.tiles.primary').on('click', function() {
    $('.navbar').removeClass(navbar_classes)
    $('.navbar').addClass('navbar-primary')
    $('.tiles').removeClass('selected')
    $(this).addClass('selected')
  })
  $('.tiles.success').on('click', function() {
    $('.navbar').removeClass(navbar_classes)
    $('.navbar').addClass('navbar-success')
    $('.tiles').removeClass('selected')
    $(this).addClass('selected')
  })
  $('.tiles.warning').on('click', function() {
    $('.navbar').removeClass(navbar_classes)
    $('.navbar').addClass('navbar-warning')
    $('.tiles').removeClass('selected')
    $(this).addClass('selected')
  })
  $('.tiles.danger').on('click', function() {
    $('.navbar').removeClass(navbar_classes)
    $('.navbar').addClass('navbar-danger')
    $('.tiles').removeClass('selected')
    $(this).addClass('selected')
  })
  $('.tiles.pink').on('click', function() {
    $('.navbar').removeClass(navbar_classes)
    $('.navbar').addClass('navbar-pink')
    $('.tiles').removeClass('selected')
    $(this).addClass('selected')
  })
  $('.tiles.info').on('click', function() {
    $('.navbar').removeClass(navbar_classes)
    $('.navbar').addClass('navbar-info')
    $('.tiles').removeClass('selected')
    $(this).addClass('selected')
  })
  $('.tiles.dark').on('click', function() {
    $('.navbar').removeClass(navbar_classes)
    $('.navbar').addClass('navbar-dark')
    $('.tiles').removeClass('selected')
    $(this).addClass('selected')
  })
  $('.tiles.default').on('click', function() {
    $('.navbar').removeClass(navbar_classes)
    $('.tiles').removeClass('selected')
    $(this).addClass('selected')
  })
}

export { listenToSettingsEvents }
